import React from "react";
import Header from "./Header";
import Hero from "./Hero";
import Approvals from "./Approvals";
import FAQ from "./FAQ";
import Footer from "./Footer";

const Home = ({ setShowModal }) => {
  return (
    <>
      <Header setShowModal={setShowModal} />
      <Hero />
      <Approvals />
      <FAQ />
      <Footer />
    </>
  );
};

export default Home;
